import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Login from '../../screens/auth/Login'
import Register from '../../screens/auth/Register'
import Reset from '../../screens/auth/Reset'
import NotFound from '../../screens/NotFound'
import Success from '../../screens/Success'
import Failure from '../../screens/Failure'
import Password from '../../screens/auth/Password'
import KitchenSink from '../../ui-library/KitchenSink'
import Auth2FA from '../../screens/auth/Auth2FA'
import Gdpr from '../../screens/dashboard/users/system/GDPR'
import DashboardContainer from '../../ui-library/components/DashboardContainer'
import UsersList from '../../screens/dashboard/users/system/UsersList'
import EditUser from '../../screens/dashboard/users/system/EditUser'
import AddUser from '../../screens/dashboard/users/system/AddUser'
import AddAppUser from '../../screens/dashboard/users/app/AddUser'
import EditAppUser from '../../screens/dashboard/users/app/EditUser'
import AppUsersList from '../../screens/dashboard/users/app/UsersList'
import GdprAppUser from '../../screens/dashboard/users/app/GDPR'
import Products from '../../screens/products/Products'
import EditProduct from '../../screens/products/EditProduct'
import AddProduct from '../../screens/products/AddProduct'
import Domains from '../../screens/domains/Domains'
import EditDomain from '../../screens/domains/EditDomain'
import AddDomain from '../../screens/domains/AddDomain'

import Orders from '../../screens/orders/Orders'
import EditOrder from '../../screens/orders/EditOrder'

import Content from '../../screens/content/List'
import EditContent from '../../screens/content/Edit'


function Router() {
  return (
    <Routes>
      {/*  AUTH ROUTES */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/authenticate" element={<Auth2FA />} />
      <Route path="/reset-password" element={<Password />} />
      {/* DASHBOARD ROUTES */}
      <Route path="/dashboard" element={<Products />} />
      <Route path="/dashboard/system" element={<UsersList />} />
      <Route path="/dashboard/system/add" element={<AddUser />} />
      <Route path="/dashboard/system/edit" element={<EditUser />} />
      <Route path="/dashboard/app" element={<AppUsersList />} />
      <Route path="/dashboard/app/add" element={<AddAppUser />} />
      <Route path="/dashboard/app/edit" element={<EditAppUser />} />
      <Route path="/dashboard/APP/gdpr" element={<GdprAppUser />} />
      <Route path="/dashboard/system/gdpr" element={<Gdpr />} />
      {/*  Videos */}
      {/* <Route path="/dashboard/videos" element={<Videos />} /> */}
      {/* <Route path="/dashboard/archive" element={<ArchivedVideos />} /> */}
      {/* <Route path="/dashboard/flagged" element={<FlaggedVideos />} /> */}

      {/*  Products */}
      <Route path="/dashboard/products" element={<Products />} />
      <Route path="/dashboard/products/edit" element={<EditProduct />} />
      <Route path="/dashboard/products/add" element={<AddProduct />} />

      <Route path="/dashboard/domains" element={<Domains />} />
      <Route path="/dashboard/domains/edit" element={<EditDomain />} />
      <Route path="/dashboard/domains/add" element={<AddDomain />} />

      <Route path="/dashboard/orders" element={<Orders />} />
      <Route path="/dashboard/orders/edit" element={<EditOrder />} />


      <Route path="/dashboard/content" element={<Content />} />
      <Route path="/dashboard/content/edit" element={<EditContent />} />

      {/* MISC */}
      {/* <Route path="/sink" element={<KitchenSink />} /> */}
      <Route path="*" element={<NotFound />} />
      <Route path="/success" element={<Success />} />
      <Route path="/failure" element={<Failure />} />
    </Routes>
  )
}

export default Router
